<template>
  <div>
    <sidenav
      :custom_class="this.$store.state.mcolor"
      :class="[
        this.$store.state.isTransparent,
        this.$store.state.isRTL ? 'fixed-end' : 'fixed-start',
      ]"
      v-if="this.$store.state.showSidenav"
    />
    <div
      v-if="this.$store.state.isPinned"
      class="sidenav-mobile-backdrop d-xl-none"
      @click="closeMobileMenu"
    ></div>
    <main
      class="main-content position-relative max-height-vh-100 h-100 border-radius-lg"
      :style="this.$store.state.isRTL ? 'overflow-x: hidden' : ''"
    >
      <!-- nav -->
      <navbar
        :class="[navClasses]"
        :textWhite="this.$store.state.isAbsolute ? 'text-white opacity-8' : ''"
        :minNav="navbarMinimize"
        v-if="this.$store.state.showNavbar"
      />
      
      <!-- Page content -->
      <div class="container-fluid py-4">
        <slot />
      </div>
      
      <app-footer v-show="this.$store.state.showFooter" />
    </main>
  </div>
</template>

<script>
import Sidenav from "../examples/Sidenav";
import Navbar from "@/examples/Navbars/Navbar.vue";
import AppFooter from "@/examples/Footer.vue";
import { mapMutations } from "vuex";
import authMixin from "@/mixins/authMixin.js";

export default {
  name: "AuthenticatedLayout",
  components: {
    Sidenav,
    Navbar,
    AppFooter,
  },
  mixins: [authMixin],
  methods: {
    ...mapMutations(["navbarMinimize"]),
    closeMobileMenu() {
      this.$store.commit("closeSidenavMobile");
    },
  },
  computed: {
    navClasses() {
      return {
        "position-sticky blur shadow-blur mt-4 left-auto top-1 z-index-sticky": this
          .$store.state.isNavFixed,
        "position-absolute px-4 mx-0 w-100 z-index-2": this.$store.state
          .isAbsolute,
        "px-0 mx-4 mt-4": !this.$store.state.isAbsolute,
      };
    },
  },
  beforeMount() {
    this.$store.state.isTransparent = "bg-transparent";
  },
};
</script>

<style scoped>
.sidenav-mobile-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1049;
}
</style>
